import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createQuickAlertsUrl } from "../../../../config";
import { DefaultTopLevelGroup, Status } from "../../../../common/constants";
import api from "../../../../api";
import { RootState } from "../../../../store";
import { IInitialSliceState } from "../../../../common/types/commonTypes";

const CREATE_QUICKALERTS: string = "createQuickAlerts";

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  reqId: null,
  msg: null,
};

export const createQuickAlerts = createAsyncThunk(
  CREATE_QUICKALERTS,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(`${createQuickAlertsUrl}?orgId=${encodeURIComponent(DefaultTopLevelGroup.ID)}`, payload);
      return response.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const createQuickAlertsSlice = createSlice({
  name: CREATE_QUICKALERTS,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createQuickAlerts.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(createQuickAlerts.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
      })
      .addCase(createQuickAlerts.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Unknown error occurred";
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

export const selector = (state: RootState) => state.createQuickAlertsApi;

export default createQuickAlertsSlice.reducer;
